$(document).ready(function(){

//SEARCH FIELD ANIMATED TEXT
var textbox = jQuery('#search_input'),
captionLength = 0,
caption = '',
search_term_number = 0,
id = setTimeout(TypingEffect, 4000);
	  
function TypingEffect() {
	const words = [
		"Aluminium Garden Furniture",
		"Special Offer",
		"Solar Orb",
		"Floating Candles",
		"Dog Treat",
		"Solar",
		"Grillstream",
		"Barcelona",
		"Dog Toys",
		"Solar Lights",
		"Compost",
		"House Plant Pots"
	];

	if (search_term_number == words.length) {
		search_term_number = 0;
	}

	caption = words[search_term_number];
	search_term_number++;
	clearTimeout(id);
	captionLength = 1;
	id = setInterval(type, 50);
}

function type() {
	textbox.attr("placeholder", "Search: " + caption.substring(0, captionLength++));
	if (captionLength === caption.length + 1) {
		clearInterval(id); 
		id = setTimeout(ErasingEffect, 1000); 
	}
}

function ErasingEffect() {
	clearTimeout(id);
	captionLength = caption.length;
	id = setInterval(erase, 50);
}

function erase() {
	textbox.attr("placeholder", "Search: " + caption.substring(0, captionLength--));
	if (captionLength < 0) {
		clearInterval(id);
		id = setTimeout(TypingEffect, 1000);
	}
}

});



$(document).ready(function(){


		jQuery('#southwood_usp').slick({
			dots: false,
			infinite: true,
			arrows: false,
			autoplay: true,
			autoplaySpeed: 3000,
			slidesToShow: 4,
			slidesToScroll: 1,
			responsive: [
                {
				breakpoint: 1000,
				settings: {
					slidesToShow: 3
				}
			},
                {
				breakpoint: 750,
				settings: {
					slidesToShow: 2
				}
			},
            {
				breakpoint: 500,
				settings: {
					slidesToShow: 1
				}
			}]
		});	






  

});







$(document).ready(function(){
	if ( $('#farm_shop').length ) {
		$('.farmshopcheckbox').change(function() {
          //$('textarea[name="custom_60302a04244f0"]').attr('readonly','readonly');
          	var labelString = "";
 			$('#farm_shop input[type=checkbox]').each(function () {  
              if($(this).is(':checked')) {
				labelString += $(this).next("label").text() + "\n";
              }
            });
          $('#order').val( labelString );  
        });
	}
});




$(document).ready(function() {

    // process the form
    $('#farmshopform').submit(function(event) {
		
		$('.form-group').removeClass('has-error'); // remove the error class
		$('.help-block').remove(); // remove the error text

        // get the form data
        // there are many ways to get this data using jQuery (you can use the class or id also)
        var formData = {
            'firstname'         : $('input[name=firstname]').val(),
			'lastname'          : $('input[name=lastname]').val(),
			'telephonenumber'   : $('input[name=telephonenumber]').val(),
            'email'             : $('input[name=email]').val(),
            'address'    : $('textarea[name=address]').val(),
			'order'              : $('textarea[name=order]').val(),
            'email'             : $('input[name=email]').val(),
			'notes'    : $('textarea[name=notes]').val()
        };

        // process the form
        $.ajax({
            type        : 'POST', // define the type of HTTP verb we want to use (POST for our form)
            url         : 'http://development.southwoodgardencentre.co.uk/process.php', // the url where we want to POST
            data        : formData, // our data object
            dataType    : 'json', // what type of data do we expect back from the server
            encode          : true
        })
            // using the done promise callback
            .done(function(data) {

                // log data to the console so we can see
                console.log(data);

                // here we will handle errors and validation messages
				if ( ! data.success) {

					// handle errors for name ---------------
					if (data.errors.firstname) {
					$('#firstname-group').addClass('has-error'); // add the error class to show red input
					$('#firstname-group').append('<div class="help-block">' + data.errors.firstname + '</div>'); // add the actual error message under our input
					}

					// handle errors for email ---------------
					if (data.errors.lastname) {
					$('#lastname-group').addClass('has-error'); // add the error class to show red input
					$('#lastname-group').append('<div class="help-block">' + data.errors.lastname + '</div>'); // add the actual error message under our input
					}
					
					if (data.errors.telephonenumber) {
					$('#telephone-group').addClass('has-error'); // add the error class to show red input
					$('#telephone-group').append('<div class="help-block">' + data.errors.telephonenumber + '</div>'); // add the actual error message under our input
					}

					// handle errors for email ---------------
					if (data.errors.email) {
					$('#email-group').addClass('has-error'); // add the error class to show red input
					$('#email-group').append('<div class="help-block">' + data.errors.email + '</div>'); // add the actual error message under our input
					}

					// handle errors for email ---------------
					if (data.errors.address) {
					$('#address-group').addClass('has-error'); // add the error class to show red input
					$('#address-group').append('<div class="help-block">' + data.errors.address + '</div>'); // add the actual error message under our input
					}
					
					// handle errors for email ---------------
					if (data.errors.order) {
					$('#order-group').addClass('has-error'); // add the error class to show red input
					$('#order-group').append('<div class="help-block">' + data.errors.order + '</div>'); // add the actual error message under our input
					}
					

				} else {
					// ALL GOOD! just show the success message!
					$('#farmshopform').html('<div class="alert alert-success">Thank you for your order. Will be in touch shortly.</div>');
				}
            })
			// using the fail promise callback
			.fail(function(data) {
              console.log(data);
			  //Server failed to respond - Show an error message
			  $('#farmshopform').html('<div class="alert alert-danger">Could not reach server, Please contact Southwood Garden Centre.</div>');
			});

        // stop the form from submitting the normal way and refreshing the page
        event.preventDefault();
    });

});